import { Page } from '../../types'

const fraudAgainstThePublic: Page[] = [
    {
        pageType: 'question',
        title: 'Fraud against the public',
        name: 'fraud-against-the-public',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'fraud-against-public-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'fraud-against-public-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'fraud-against-public-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default fraudAgainstThePublic
